export default function (type, data) {
  if (!type) return
  if (document.createEvent) {
    var ev = document.createEvent("CustomEvent")
    ev.initCustomEvent(type, true, true, data)
    window.dispatchEvent(ev)
  } else {
    document.fireEvent(type, data)
  }
}
